
<template>
  <div class="PacienteDetalleGarantias">
    <v-card
      outlined
      :disabled="cargando"
      :loading="cargando"
    >
      <v-card-title>
        Garantías del paciente
      </v-card-title>
      <v-data-table
        class="upper"
        :headers="headers"
        :items="garantias"
        :loading="cargando"
        loading-text="Cargando..."
      >
        <template v-slot:item.fecha_cgo="{item}">
          {{_doDiaMes(item.fecha_cgo)}}
        </template>
        <template v-slot:item.caducidad="{item}">
          {{_doDiaMes(item.caducidad)}}
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>
<script>
import forms from "@/mixins/forms.js";
import dates from "@/mixins/dates.js";
export default {
  name: "PacienteDetalleGarantias",
  mixins: [forms, dates],
  props: {
    id: [String, Number],
  },
  data() {
    return {
      search: "",
      garantias: [],
      headers: [
        { text: "Servicio", value: "desc_ser" },
        { text: "Cargo", value: "id_cgo" },
        { text: "Fecha de cargo", value: "fecha_cgo" },
        { text: "Vigencia garantía", value: "caducidad" },
      ],
      paciente: null,
    };
  },
  methods: {
    _getGarantias() {
      if (this.id) {
        this._getThings("garantias/" + this.id, "garantias");
      }
    },
  },
  created() {
    this.paciente = this.id;
    this._getGarantias();
  },
  watch: {
    id() {
      this.paciente = this.id;
      this._getGarantias();
    },
  },
};
</script>

